import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to,from,next)=>{
  if(sessionStorage.user == 'null'){
  // if(sessionStorage.user == 'nouser'){
    next('/')
  }else{
    next()
  }
})

